import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import './readyLearnLanding.style.css';
import Forward from '../../images/arrow-forward.svg';

import { useHistory } from 'react-router';
const ReadyLearnLandingComponent = () => {
    const history = useHistory();

    const uploadDocsRoute = () => {
        let queryString = "?d1s=" + selectedStep1.name + "&d1d=" + selectedStep1.document + "&d2s=" + selectedStep2.name + "&d2d=" + selectedStep2.document;
        window.location.href = 'https://upload.incomemax.org.uk' + queryString;
    }

    const optOutRoute = () => {
        history.push('/opt-out')
    }

    const [step1Data, setStep1Data] = useState([]);
    const [step2Data, setStep2Data] = useState([]);
    const [selectedStep1, setSelectedStep1] = useState({ name: "", value: [] });
    const [selectedStep2, setSelectedStep2] = useState({ name: "", value: [] });
    const [pension, setPension] = useState(false);

    const step1Clicked = (item) => {
        setSelectedStep1(item)
        setSelectedStep2({ name: "", value: [] })
        setStep1Data(defaultData)
        
        // Clear step2Data and set pension state based on the selected item
        if (item.value === "pension") {
            setStep2Data([])
            setPension(true)
        } else {
            setPension(false)
            setStep2Data(item.value || [])
        }
    }

    const step2Clicked = (item) => {
        setSelectedStep2(item)
    }

    useEffect(() => {
        setStep1Data(defaultData)
    }, []);

    const step2view = () => {
        // Only show step2view if we have step2Data and pension is false
        if (!step2Data.length || pension) return null;
        return <div className="ready-learn-body">
            <div className="left">
                <h4>Step 2</h4>
                <h3>Which of the following applies to you?</h3>
                <p>If none of these options apply to you, scroll up to question 1 and select another option that's relevant.</p>
                <div className="options-container">
                    {step2Data.map(function (item, index) {
                        return <p value={item.name} onClick={() => step2Clicked(item)} className={selectedStep2.name == item.name ? 'option-selected' : 'option'} key={index}>{item.name}</p>;
                    })}
                </div>
            </div>
            <div>
                <p><strong>Need help?</strong> Give us a call 0300 777 7772</p>
            </div>
        </div>
    }

    // Rest of the component remains the same...
    const step1view = () => {
        if (!step1Data.length) return;
        return <div className="ready-learn-body">
            <div className="left">
                <h4>Step 1</h4>
                <h3>Which of the following applies to you?</h3>
                <p>You only need to select one option. If more than one applies to you, just pick one.</p>
                <div className="options-container">
                    {step1Data.map(function (item, index) {
                        return <p value={item.name} onClick={() => step1Clicked(item)} className={selectedStep1.name == item.name ? 'option-selected' : 'option'} key={index}>{item.name}</p>;
                    })}
                </div>
            </div>
            <div className="right">
                <div className="opt-in-box">
                    <h3>Not sure this applies to you?</h3>
                    <p>You can opt out here and self-declare as ineligible. You will not be contacted again.</p>
                    <Button onClick={optOutRoute} className="signup-btn learn-btn">
                        Opt out <img src={Forward} />
                    </Button>
                </div>
                <p className="need-help-message"><strong>Need help?</strong> Give us a call 0300 777 7772</p>
            </div>
        </div>
    }

    const step3view = () => {
        if (!selectedStep2.name) return;
        return <div className="document-upload-container">
            <div>
                <h4>Step 3</h4>
                <h3>Upload the relevant documents</h3>
                <p>Thank you. Below is a summary of the documents we will need from you. When you are ready, click on the upload button to begin.</p>
            </div>
            <div className="document-upload-list-container ">
                <div className="file-container">
                    <p>You selected:</p>
                    <p className="result-item">{selectedStep1.name}</p>
                    <p>We need:</p>
                    <p className="result-item">{selectedStep1.document}</p>
                </div>
                <div className="file-container">
                    <p>You selected:</p>
                    <p className="result-item">{selectedStep2.name}</p>
                    <p>We need:</p>
                    <p className="result-item">{selectedStep2.document}</p>
                </div>
            </div>
            <div className="btn-container">
                <Button className="dark-btn-whd" onClick={uploadDocsRoute}>Ready to upload</Button>
            </div>
        </div>
    }
    

    const pensionView = () => {
        if (!pension) return;
        return <div className="document-upload-container">
            <div>
                <h4>Step 2</h4>
                <h3>Upload the relevant documents</h3>
                <p>Thank you. Below is a summary of the documents we will need from you. When you are ready, click on the upload button to begin.</p>
            </div>
            <div className="document-upload-list-container ">
                <div className="file-container">
                    <p>You selected:</p>
                    <p className="result-item">{selectedStep1.name}</p>
                    <p>We need:</p>
                    <p className="result-item">{selectedStep1.document}</p>
                </div>
            </div>
            <div className="btn-container">
                <Button className="dark-btn-whd" onClick={uploadDocsRoute}>Ready to upload</Button>
            </div>
        </div>
    }

    return (
        <>
            {step1view()}
            {step2view()}
            {step3view()}
            {pensionView()}
        </>
    )
}

const defaultData = [
  {
    name: "I'm on Income Support",
    document:
      "Income Support Notice of Entitlement Letter dated from April 2025 – every page needed",
    value: [
      {
        name: "I have parental responsibility for a child under the age of 5 who ordinarily resides with me",
        document:
          "A scan of your child's birth certificate (every page) or a scan of their passport (photo page)",
      },
      {
        name: "A disabled child premium which includes a disability or severe disability element",
        document:
          "Proof of Housing Benefit or Council Tax Support letter dated from April 2025",
      },
      {
        name: "I receive a disability premium, enhanced disability premium, or severe disability premium",
        document:
          "A scan of your Income Support Notice of Entitlement benefit letter dated from April 2025 (every page)",
      },
      {
        name: "I, or another adult living with me, receives Disability Living Allowance, Personal Disability Payment or Attendance Allowance",
        document:
          "A scan of the Disability Benefit Notice of Entitlement letter, dated from April 2025 (every page, including all awards)",
      },
      {
        name: "I receive a pensioner premium, higher pensioner premium or enhanced pensioner premium",
        document:
          "A scan of your Income Support Notice of Entitlement letter, dated from April 2025 (every page)",
      },
      {
        name: "I receive Carer's Allowance",
        document:
          "A scan of your Income Support Notice of Entitlement benefit letter, dated from April 2025 (every page)",
      },
      {
        name: "Hold a Maternity Exemption Certificate (MATEX), Hold a Medical Exemption Certificate (MEDEX)",
        document: "Proof of certificate",
      },
      {
        name: "Adult Disability payment, Pension Age Disability Payment, Child Disability Payments",
        document:
          "A scan of the disability benefit letter dated from April 2025",
      },
    ],
  },
  {
    name: "Housing Benefit",
    document:
      "Housing Benefit Notice of Entitlement Letter dated from April 2025 - every page showing the calculation",
    value: [
      {
        name: "Has parental responsibility for a child under the age of 5 who ordinarily resides with you",
        document:
          "Housing benefit notice of entitlement dated from April 2025 (every page) or A scan of your child's birth certificate or a scan of their passport (photo page)",
      },
      {
        name: "Receives a disabled child premium which includes a disability or severe disability element",
        document:
          "Housing benefit notice of entitlement dated April 2025 (every page)",
      },
      {
        name: "Receives a disability premium, enhanced disability premium or severe disability premium",
        document:
          "Housing benefit notice of entitlement dated April 2025 (every page)",
      },
      {
        name: "Receives Disability Living Allowance, Personal Independence Payment or Attendance Allowance for you or another adult living with you",
        document:
          "A scan of a the disability benefit notice of entitlement dated from April 2025",
      },
      {
        name: "Receives a pensioner premium, higher pensioner premium or enhanced pensioner premium",
        document:
          "Housing benefit notice of entitlement dated from April 2025 (every page)",
      },
      {
        name: "Adult Disability payment, Pension Age Disability Payment, Child Disability Payments",
        document:
          "A scan of a the disability benefit notice of entitlement dated from April 2025",
      },
      {
        name: "Hold a Maternity Exemption Certificate (MATEX), Hold a Medical Exemption Certificate (MEDEX)",
        document: "Proof of certificate",
      },
    ],
  },
  {
    name: "I receive Income-Related Employment and Support Allowance",
    value: [
      {
        name: "I receive a work-related activity or support group component",
        document:
          "A scan of your ESA Notice of Entitlement benefit letter, dated from April 2025 (every page)",
      },
      {
        name: "I have parental responsibility for a child under the age of 5 who ordinarily resides with me",
        document:
          "A scan of the child's birth certificate (both pages) or a scan of their passport (photo page)",
      },
      {
        name: "A disabled child premium which includes a disability or severe disability element",
        document:
          "Proof of Housing Benefit or Council Tax Support letter dated from April 2025",
      },
      {
        name: "I receive a disability premium, enhanced disability premium, severe disability premium",
        document:
          "A scan of your Employment Support Allowance Notice of Entitlement benefit letter dated from April 2025 (every page)",
      },
      {
        name: "I, or another adult living with me, receives Disability Living Allowance, Personal Disability Payment or Attendance Allowance",
        document:
          "A scan of the Disability Benefit Notice of Entitlement letter, dated from April 2025 (every page, including all awards)",
      },
      {
        name: "I receive a pensioner premium, higher pensioner premium or enhanced pensioner premium",
        document:
          "A scan of your ESA Notice of Entitlement benefit letter, dated from April 2025 (every page needed)",
      },
      {
        name: "Hold a Maternity Exemption Certificate (MATEX), Hold a Medical Exemption Certificate (MEDEX)",
        document: "Proof of certificate",
      },
      {
        name: "Adult Disability payment, Pension Age Disability Payment, Child Disability Payments",
        document:
          "A scan of the disability benefit letter dated from April 2025",
      },
    ],
    document:
      "A scan of your ESA Notice of Entitlement benefit letter, dated from April 2025 (every page)",
  },
  {
    name: "I receive Income-based Jobseekers Allowance",
    value: [
      {
        name: "I have parental responsibility for a child under the age of 5 who ordinarily resides with me",
        document:
          "A scan of your child's birth certificate (every page) or a scan of their passport (photo page)",
      },
      {
        name: "A disabled child premium which includes a disability or severe disability element",
        document:
          "Proof of Housing Benefit or Council Tax Support letter dated from April 2025",
      },
      {
        name: "I receive a disability premium, enhanced disability premium, or severe disability premium",
        document:
          "A scan of your Jobseekers Allowance Notice of Entitlement benefit letter dated from April 2025 (every page)",
      },
      {
        name: "I, or another adult living with me, receives Disability Living Allowance, Personal Disability Payment or Attendance Allowance",
        document:
          "A scan of the Disability Benefit Notice of Entitlement letter, dated from April 2025 (every page, including all awards)",
      },
      {
        name: "I receive a pensioner premium, higher pensioner premium or enhanced pensioner premium",
        document:
          "A scan of your Jobseekers Allowance of Entitlement benefit letter, dated from April 2025 (every page needed)",
      },
      {
        name: "Hold a Maternity Exemption Certificate (MATEX), Hold a Medical Exemption Certificate (MEDEX)",
        document: "Proof of certificate",
      },
      {
        name: "Adult Disability payment, Pension Age Disability Payment, Child Disability Payments",
        document:
          "A scan of the disability benefit letter dated from April 2025",
      },
    ],
    document:
      "A scan of your JSA Notice of Entitlement benefit letter, dated from April 2025 (every page)",
  },
  {
    name: "Universal Credit and have earned less than £1,694 in at least one month since 1st October 2024 and one of the following:",
    message:
      "If you are on Universal Credit as a jobseeker, please return to Step 1 and select gross taxable annual household income of less than £19,978.",
    value: [
      {
        name: "I receive the limited capability for work element of Universal Credit, with or without a work-related activity",
        document:
          "Screenshot(s) of a monthly statement from your online journal, for one month since 1st October 2024; or a scan of your full Universal Credit Notice of Entitlement letter, dated from 1st October 2024 (every page)",
      },
      {
        name: "I receive the disabled child element of Universal Credit",
        document:
          "Screenshot(s) of a monthly statement from your online journal, for one month since 1st October 2024; or a scan of your full Universal Credit Notice of Entitlement letter, dated from 1st October 2024 (every page)",
      },
      {
        name: "I, or another adult living with me, receives Disability Living Allowance, Personal Disability Payment or Attendance Allowance",
        document:
          "A scan of the Disability Benefit Notice of Entitlement letter, dated from April 2025 (every page, including all awards)",
      },
      {
        name: "I receive the child element of Universal Credit for a dependent child who ordinarily resides with me",
        document:
          "Screenshot(s) of a monthly statement from your online journal, for one month since 1st October 2024; or a scan of your full Universal Credit Notice of Entitlement letter, dated from 1st October 2024 (every page)",
      },
      {
        name: "Is in receipt of Carers Element",
        document:
          "Screenshot(s) of a monthly statement from your online journal, for one month since 1st October 2024; or a scan of your full Universal Credit Notice of Entitlement letter, dated from 1st October 2024 (every page)",
      },
      {
        name: "Is in receipt of housing element of Universal Credit",
        document:
          "Screenshot(s) of a monthly statement from your online journal, for one month since 1st October 2024; or a scan of your full Universal Credit Notice of Entitlement letter, dated from 1st October 2024 (every page)",
      },
      {
        name: "Hold a Maternity Exemption Certificate (MATEX), Hold a Medical Exemption Certificate (MEDEX)",
        document: "Proof of certificate",
      },
      {
        name: "Adult Disability payment, Pension Age Disability Payment, Child Disability Payments",
        document:
          "A scan of the disability benefit letter dated from April 2025",
      },
    ],
    document:
      "Screenshot(s) of a monthly statement from your online journal, for one month since 1st October 2024; or a scan of your full Universal Credit Notice of Entitlement letter, dated from 1st October 2024 (every page)",
  },
  {
    name:
      "Gross taxable annual household Income (HHI)* of less than £25,000 and one of the following:",
    value: [
      {
        name: "I receive Child Benefit for a dependent child who ordinarily resides with me",
        document:
          "A scan (every page) of the Child Benefit letter; or Housing Benefit / Council Tax Support Notice of Entitlement letter dated from April 2025.",
      },
      {
        name: "I receive Disability Living Allowance; or Personal Independence Payment; or Attendance Allowance for me or another adult living with me",
        document:
          "A scan of the disability benefit award letter dated from April 2025",
      },
      {
        name: "I receive Carer's Allowance",
        document:
          "A scan of your carers allowance award letter dated from April 2025",
      },
      {
        name: "I am aged 60 or over",
        document: "Proof of your date of birth eg, passport or driving license",
      },
      {
        name: "I am in employment",
        document:
          "3 consecutive payslips. 3 months bank statements as a last resort dated from April 2025",
      },
      {
        name: "I previously served in the armed forces",
        document: "Proof of being in the armed forces.",
      },
      {
        name: "Receives Job Seekers Allowance or Universal Credit as a job seeker",
        document:
          "JSA Notice of Entitlement letter dated from April 2025 or screenshots of 3 consecutive months of Universal Credit statements from 1st October 2024.",
      },
      {
        name: "Adult Disability payment, Pension Age Disability Payment, Child Disability Payments",
        document:
          "A scan of the disability benefit award letter dated from April 2025",
      },
      {
        name: "Hold a Maternity Exemption Certificate (MATEX), Hold a Medical Exemption Certificate (MEDEX)",
        document: "Proof of certificate",
      },
      {
        name: "Hold a valid war pension NHS exemption certificate and the prescription is for your disability",
        document: "Proof of certificate",
      },
    ],
    document:
      "Last 3 consecutive months of wage slips if working, pension letters dated from April 2025, housing benefit or council tax support notice of entitlement letters dated from April 2025, Benefit award letters dated from April 2025 - every page needed. (bank statements as a last resort)",
  },
  {
    name: "In receipt of Council Tax Support/Reduction",
    value: [
      {
        name: "Gross taxable annual household Income (HHI)* of less than £25,000 - this includes savings, pensions and your partner’s income",
        document:
          "Last 3 consecutive months of wage slips if working, pension letters dated from April 2025, housing benefit or council tax support notice of entitlement letters dated from April 2025, Benefit award letters dated from April 2025 - every page needed. (bank statements as a last resort)",
      },
      {
        name: "Has parental responsibility for a child under the age of 5 who ordinarily resides with you",
        document:
          "Council Tax Support notice of entitlement dated from April 2025 (every page) or A scan of your child's birth certificate or a scan of their passport (photo page)",
      },
    ],
    document:
      "Council Tax Support Notice of Entitlement letter dated from April 2025",
  },
  {
    name: "Armed Forces Independence Payment (AFIP)",
    document: "Proof of AFIP letter dated from April 2025",
    value: [
      {
        name: "In receipt of or another adult at the property receives this",
        document: "Proof of letter dated from April 2025",
      },
    ],
  },
  {
    value: "pension",
    name: "I receive Pension Credit – Savings Credit ONLY",
    document:
      "A scan of your Pension Credit Notice of Entitlement letter, dated from April 2025 (every page)",
  },
  {
    value: "pension",
    name: "I receive Pension Credit – Guarantee",
    document:
      "If you received your Pension Credit before 24th August 2025 and was named on the energy bill you should receive the rebate automatically and won't need to apply again. If you received it after that date, scan your Pension Credit Notice of Entitlement Award Letter dated from April 2025 (every page)",
  },
];



export default ReadyLearnLandingComponent;